import { z } from 'zod';

import { GetPlatformV1AuditLogsActorType } from '@nucleus-commerce/api-client/platform';

const DAY = /^\d{4}-\d{2}-\d{2}$/;

const optionalText = (max: number) => z.string().trim().min(1).max(max).optional().catch(undefined);

/**
 * URL search of /audit-log. Days are UTC calendar days (the platform has no timezone); the API
 * takes instants, so `auditLogParams` turns `to` into the start of the following day.
 */
export const auditLogSearchSchema = z.object({
  organizationId: optionalText(64),
  actorType: z.enum(GetPlatformV1AuditLogsActorType).optional().catch(undefined),
  action: optionalText(120),
  entityType: optionalText(80),
  from: z.string().regex(DAY).optional().catch(undefined),
  to: z.string().regex(DAY).optional().catch(undefined),
});

export type AuditLogSearch = z.infer<typeof auditLogSearchSchema>;

/** The filter half of the form; the same keys as the URL, blanks as empty strings. */
export const auditLogFilterFormSchema = z
  .object({
    organizationId: z.string(),
    actorType: z.string(),
    action: z.string().trim().max(120, { error: 'auditLog:validation.tooLong' }),
    entityType: z.string().trim().max(80, { error: 'auditLog:validation.tooLong' }),
    from: z.string(),
    to: z.string(),
  })
  .refine((values) => !values.from || !values.to || values.from <= values.to, {
    path: ['to'],
    error: 'auditLog:validation.toBeforeFrom',
  });

export type AuditLogFilterForm = z.infer<typeof auditLogFilterFormSchema>;
